import { BaSeFooter, BaSeTheme } from '@base/react';
import * as React from 'react';
import { version } from '../../../package.json';
import { azulFluxoCaixa, FooterContainer } from './layout-styled';

export const Footer = () => {
  const { white } = BaSeTheme.colors.defaultColors;
  return (
    <FooterContainer>
      <BaSeFooter
        collapsedBreakpoint="onMobileSmall"
        backgroundColor={azulFluxoCaixa}
        separatorColor={white}
        textColor={white}
        linkColor={white}
        delimitedOnBreakpoint="desktop"
        systemVersion={version}
        systemName="Fluxo de Caixa"
        relationText=""
        collapsedHeader="Conheça o Sebrae"
        links={[
          {
            label: 'Conheça o Sebrae',
            link: 'https://www.sebrae.com.br/sites/PortalSebrae/institucional',
          },
        ]}
      />
    </FooterContainer>
  );
};
